import { ReduxUtils } from '../dependencies';

export const Modals = ReduxUtils.strictObjectAccess({
    CHANGE_EXPORTED_EXPENSE: 'CHANGE_EXPORTED_EXPENSE',
});
